import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { openobserveRum } from '@openobserve/browser-rum';
import { openobserveLogs } from '@openobserve/browser-logs';
var initialized = false;
/**
 * Initialize OpenObserve RUM (Real User Monitoring) in the browser.
 *
 * Captures, in one SDK shipped to OpenObserve: JS errors/exceptions (symbolicated
 * via uploaded source maps), Core Web Vitals, resource + long-task timing,
 * user-interaction traces, and session replay. Replaces the previous generic
 * OpenTelemetry web-tracing setup that exported to SigNoz.
 *
 * Off by default: a no-op unless `NEXT_PUBLIC_OPENOBSERVE_RUM_CLIENT_TOKEN` and
 * `NEXT_PUBLIC_OPENOBSERVE_RUM_APPLICATION_ID` are set, so it ships dormant and is
 * enabled per-environment via env (Vercel) without a code change. Safe to call
 * multiple times — only the first call wires the SDK.
 *
 * Source-map symbolication matches an error to its map on `service` + `version` +
 * `env`, so those three MUST line up with what the build uploads. On Vercel set
 * `version` to the commit SHA (`NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA`) so each deploy
 * lines up with the maps uploaded for that build.
 *
 * @param service - the calling app's own service name (e.g. `restworld-worker-app`),
 * matching what that app's build uploads maps under so RUM data + symbolication line up
 * per app. `NEXT_PUBLIC_OPENOBSERVE_SERVICE` overrides it when set.
 */

export function initOpenObserveRum() {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _ref2, _process$env$NEXT_PUB3, _process$env$NEXT_PUB4;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      serviceArg = _ref.service;

  if (initialized || false) {
    return;
  }

  var clientToken = process.env.NEXT_PUBLIC_OPENOBSERVE_RUM_CLIENT_TOKEN;
  var applicationId = process.env.NEXT_PUBLIC_OPENOBSERVE_RUM_APPLICATION_ID; // Both are required to activate; without them RUM stays off (dormant build).

  if (!clientToken || !applicationId) {
    return;
  }

  initialized = true;
  var site = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_OPENOBSERVE_SITE) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : 'eu1-api.openobserve.ai';
  var organizationIdentifier = (_process$env$NEXT_PUB2 = process.env.NEXT_PUBLIC_OPENOBSERVE_ORG) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : '';
  var service = (_ref2 = (_process$env$NEXT_PUB3 = process.env.NEXT_PUBLIC_OPENOBSERVE_SERVICE) !== null && _process$env$NEXT_PUB3 !== void 0 ? _process$env$NEXT_PUB3 : serviceArg) !== null && _ref2 !== void 0 ? _ref2 : 'restworld-employer-app';
  var env = (_process$env$NEXT_PUB4 = process.env.NEXT_PUBLIC_OPENOBSERVE_ENV) !== null && _process$env$NEXT_PUB4 !== void 0 ? _process$env$NEXT_PUB4 : 'development'; // `||` (not `??`) so an empty-string env (e.g. unset VERCEL_GIT_COMMIT_SHA on a local build) falls through.

  var version = process.env.NEXT_PUBLIC_OPENOBSERVE_VERSION || process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || 'dev';
  var apiBaseUrl = process.env.NEXT_PUBLIC_BASE_API_URL;
  openobserveRum.init(_objectSpread({
    applicationId: applicationId,
    clientToken: clientToken,
    site: site,
    organizationIdentifier: organizationIdentifier,
    service: service,
    env: env,
    version: version,
    sessionSampleRate: 100,
    // Session replay ON. (PostHog also records replays; kept on here while we evaluate
    // OpenObserve's replay — note replay is the heaviest RUM signal, DOM snapshots.)
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    apiVersion: 'v1',
    insecureHTTP: false,
    // Privacy default still applies to any captured interaction data.
    defaultPrivacyLevel: 'mask-user-input'
  }, apiBaseUrl ? {
    allowedTracingUrls: [{
      match: apiBaseUrl,
      propagatorTypes: ['tracecontext']
    }]
  } : {})); // Mirror RUM errors into a logs stream too, so they're searchable/alertable on
  // the logs side as well as in RUM error tracking.

  openobserveLogs.init({
    clientToken: clientToken,
    site: site,
    organizationIdentifier: organizationIdentifier,
    service: service,
    env: env,
    version: version,
    apiVersion: 'v1',
    insecureHTTP: false,
    forwardErrorsToLogs: true
  });
  openobserveRum.startSessionReplayRecording();
}